var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightGraphicArrowMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 166,
    viewBox: "0 0 115 166",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5851 14.6954C39.0073 14.6954 30.7076 77.7516 51.9799 89.8251C68.9361 99.4488 76.2651 76.1695 60.6871 70.5776C45.1092 64.9857 26.1842 90.2798 26.1842 107.694C26.1842 118.658 25.7259 136.565 44.1477 155.238",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 1.24351,
    strokeDasharray: "3.67 3.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1552 155.753L47.0446 157.182C46.5507 157.852 46.5507 157.852 45.7536 158.092C44.5002 157.77 42.6811 157.132 41.4163 156.962C41.1675 156.936 40.2993 156.639 39.5278 156.445C38.8702 156.279 38.1289 157.115 38.7303 157.428C40.3341 158.159 41.9968 158.868 43.7298 159.405C44.999 159.769 47.2308 160.136 47.9659 159.592C48.5818 159.137 48.9383 156.857 48.7513 155.802L48.7512 155.801C48.4332 154.208 48.1153 152.614 47.7385 151.042C47.6438 150.452 47.1828 150.545 47.1033 151.137C46.8785 152.344 47.2546 153.869 47.1552 155.753Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGraphicArrowMobile);
export default __webpack_public_path__ + "static/media/right-graphic-arrow-mobile.9ec22a7e.svg";
export { ForwardRef as ReactComponent };